export const calculateProgress = (totalQuestions, questionsLeft) => {
  return (questionsLeft / totalQuestions) * 100;
};
